<script setup lang="ts">
import GenerateAssessmentTile from '../assessments/GenerateAssessmentTile.vue'
import GeneratedAssessmentTile from '../assessments/GeneratedAssessmentTile.vue'
import type { GeneratedAssessment } from '../assessments/generated_assessment_types'

withDefaults(defineProps<{
  assessments: GeneratedAssessment[]
  targetLabel: string
  isGenerateShown?: boolean
  blockedReason?: string | null
}>(), {
  isGenerateShown: false,
  blockedReason: null
})

const emit = defineEmits<{
  generate: []
  deleted: [uuid: string]
}>()
</script>

<template>
  <GeneratedAssessmentTile
    v-for="assessment in assessments"
    :key="assessment.uuid"
    :assessment="assessment"
    :is-deletable="isGenerateShown"
    @deleted="emit('deleted', $event)"
  />
  <!-- Last on purpose: the empty slot reads as the next one along from the assessments that exist. -->
  <GenerateAssessmentTile
    v-if="isGenerateShown"
    :target-label="targetLabel"
    :blocked-reason="blockedReason"
    @generate="emit('generate')"
  />
</template>
